export default __webpack_public_path__ + "static/media/arrow.20002c1c.svg";